import Chart from "react-apexcharts";
import { Stack } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { ChartHeader } from "../ChartHeader";
import { ChartYaxisTitle } from "../ChartYaxisTitle";
import { useSearchCoverageChartController } from "./SearchCoverageChart.controller";
import { CHART_HEIGHT } from "../ChartConstants";
import type { Metric } from "../../../types/metrics";
import "../Charts.css";

export type SearchCoverageAirlineSeries = { airlineCode: string; airlineName: string; metric: Metric };

export type SearchCoverageChartProps = {
  series: SearchCoverageAirlineSeries[];
  showAirlineLabel?: boolean;
};

export const SearchCoverageChart = ({ series, showAirlineLabel = false }: SearchCoverageChartProps) => {
  const i18n = useI18n();
  const {
    averageCoverage,
    options,
    series: chartSeries,
  } = useSearchCoverageChartController({ series, showAirlineLabel });
  const multiSeries = chartSeries.length > 1;

  return (
    <Stack gap={multiSeries ? 4 : 0}>
      <ChartHeader
        titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_name"))}
        titleTooltipText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_tooltip"))}
        subtitleText={
          multiSeries ? undefined : i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_subheader"))
        }
        subtitleValue={multiSeries ? undefined : `${averageCoverage}%`}
      />
      <Stack mixin={{ position: "relative" }}>
        <ChartYaxisTitle titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_yaxis"))} />
        <Chart options={options} series={chartSeries} type="bar" height={CHART_HEIGHT} />
      </Stack>
    </Stack>
  );
};
